import { render, staticRenderFns } from "./NavBurger.vue?vue&type=template&id=ff127342&"
import script from "./NavBurger.vue?vue&type=script&lang=js&"
export * from "./NavBurger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports